package music.jammers.client.shared.component.card.info.presentation.viewmodel

import androidx.compose.runtime.State
import androidx.compose.runtime.mutableStateOf
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import kotlinx.coroutines.CoroutineExceptionHandler
import kotlinx.coroutines.launch
import music.jammers.client.shared.component.update
import music.jammers.client.shared.event.domain.usecase.GetCardInfoUseCase
import music.jammers.shared.event.domain.model.CardInfo

class CardInfoViewModel(
    private val getCardInfoUseCase: GetCardInfoUseCase,
) : ViewModel() {

    internal val state: State<CardInfoState> get() = _state
    private val _state = mutableStateOf(CardInfoState())

    fun onReady() {
        viewModelScope.launch(
            CoroutineExceptionHandler { _, throwable ->
                _state.update {
                    copy(
                        error = throwable,
                    )
                }
            }
        ) {
            val cardInfoList = getCardInfoUseCase()

            _state.update {
                copy(
                    items = cardInfoList,
                    error = null,
                )
            }
        }
    }

    fun onSelected(selected: CardInfo) {
        _state.update {
            copy(
                selected = selected,
                error = null,
            )
        }
    }
}